<template>
  <div class="w-full overflow-hidden relative ">
    <div class="relative">
      <ul ref="ul" class="zt-tab--ul w-full relative flex p-0 flex-no-wrap" :class="[`zt-tab-ul-${alignment}`]">
        <li class="zt-tab--li border border-zt-dark-300 block" :class="{ 'child-active': childActive === index }"
          ref="li" v-for="(child, index) in children" :key="index">
          <button class="h-full py-3 px-8 cursor-pointer m-0" :class="theme === 'primary' ? 'zt-tab--btn ' : 'zt-tab--btn_secondary '
            " v-bind="child.attrs" v-on="child.attrs" type="button" @click="activeChild(index)">
            <VNode v-if="child.title" :vnode="child.title" />
            <span v-else>{{ child.label }}</span>
          </button>
        </li>
      </ul>
    </div>
    <div class="relative overflow-hidden">
      <slot />
    </div>
  </div>
</template>

<script>
import VNode from './VNode'

export default {
  name: 'ztTab',
  inheritAttrs: false,
  components: { VNode },
  props: {
    value: {
      default: 0,
      type: [Number, String],
    },
    alignment: {
      default: 'left',
      type: String,
    },
    theme: {
      default: 'primary',
      type: String,
    },
  },
  data() {
    return {
      children: [],
      childActive: 0,
    }
  },
  provide() {
    return {
      children: () => this.getChildren(),
      updateChildren: (element) => this.updateChildren(element),
      updateChildrenById: (id, value) => this.updateChildrenById(id, value),
    }
  },
  mounted() {
    const activeIndex = this.parseIndex(this.value)
    this.childActive = activeIndex
    this.$nextTick(() => {
      this.activeChild(activeIndex, true)
    })
  },
  watch: {
    value(val) {
      const activeIndex = this.parseIndex(val)
      this.activeChild(activeIndex)
      this.$nextTick(() => {
        this.activeChild(activeIndex, true)
      })
    },
  },
  methods: {
    getChildren() {
      return this.children
    },
    updateChildren(element) {
      this.children.push(element)
      this.$nextTick(() => {
        const activeIndex = this.parseIndex(this.value)
        this.activeChild(activeIndex, true)
      })
    },
    updateChildrenById(id, value) {
      if (this.children[id]) {
        this.$set(this.children[id], 'label', value)
      }
    },
    parseIndex(index) {
      let activeIndex = this.childActive
      if (index < 0) {
        activeIndex = 0
      } else if (index >= this.children.length && this.children.length > 0) {
        activeIndex = this.children.length - 1
      } else if (this.children[index] && typeof (this.children[index].attrs || {}).disabled === 'undefined') {
        activeIndex = parseInt(index)
      }
      return activeIndex
    },
    activeChild(index, force) {
      if (!this.children || this.children.length === 0) return
      this.children.forEach((item, item_index) => {
        if (item_index !== index && item && typeof item.updateActive === 'function') {
          item.updateActive(false)
        }
      })
      if (this.children[index] && typeof this.children[index].updateActive === 'function') {
        this.children[index].updateActive(true)
        this.childActive = index
      }
      this.$emit('input', index)
    },
  },
}
</script>

<style lang="css" scoped src="../../../../../src/styles/components/ztTab.css"></style>
